// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.inspection-onsite-document-card-container {
  flex-grow: 1;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/inspection/cards/InspectionOnsiteDocumentCard.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["\n.inspection-onsite-document-card-container {\n  flex-grow: 1;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
